import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import Workspace from './views/Workspace.vue'
import Staff from './views/rights/Staff.vue'
import Supplier from './views/rights/Supplier.vue'
import Dashboard from './views/dashboard/Dashboard.vue'
import BigScreen from './views/statistics/BigScreen.vue'
import Role from './views/rights/Role.vue'
import Module from './views/rights/Module.vue'
import Selfinfo from './views/settings/Selfinfo.vue'
import Brand from './views/product/Brand.vue'
import Category from './views/product/Category.vue'
import CategoryProperty from './views/property/CategoryTemplate.vue'
import CategoryLabel from './views/product/CategoryLabel.vue'
import Article from './views/article/Article.vue'
import User from './views/user/User.vue'
import Apply from './views/user/Apply.vue'
import Template from './views/property/Template.vue'
import Property from './views/property/Property.vue'
import Value from './views/property/Value.vue'
import SelectProperty from './views/property/SelectProperty.vue'
import Company from './views/rights/Company.vue'
import CustomerProduct from './views/agreement/CustomerProduct.vue'
import Agreement from './views/agreement/Agreement.vue'
import AgreementDetail from './views/agreement/AgreementDetail.vue'
import Rfq from './views/rfq/Rfq.vue'
import RfqDetail from './views/rfq/RfqDetail.vue'
import Quote from './views/rfq/Quote.vue'
import RfqMgn from './views/rfq/RfqMgn.vue'
import RfqDetailMgn from './views/rfq/RfqDetailMgn.vue'
// import Supplier from './views/rfq/Supplier.vue'
import SupplierQuote from './views/rfq/SupplierQuote.vue'
// import Store from './views/rfq/Store.vue'
import StoreRfqDetail from './views/rfq/StoreRfqDetail.vue'
import Banner from './views/banner/Banner.vue'
import AddProduct from './views/product/AddProduct.vue'
import AddOneProduct from './views/product/AddOneProduct.vue'
import ProductSet from './views/product/ProductSet.vue'
import Product from './views/product/Product.vue'
import ProductGroup from './views/product/Group.vue'
import BrandBanner from './views/brandBanner/BrandBanner.vue'
import ReviewProduct from './views/product/ReviewProduct.vue'
import ManagerReviewProduct from './views/product/ManagerReviewProduct.vue'
import StatisticsUser from './views/statistics/StatisticsUser.vue'
import PopularProducts from './views/statistics/PopularProducts.vue'
import PopularSearch from './views/statistics/PopularSearch.vue'
import StatisticsSupplier from './views/statistics/Supplier.vue'
import OrderStatistics from './views/statistics/OrderStatistics.vue'
import customerReview from './views/customer/Review.vue'
import customerReviewDetail from './views/customer/Detail.vue'
import SupplierCompany from './views/supplier/Company.vue';
import CustomerCompany from './views/agreement/Company.vue';
import orderReview from './views/order/Review.vue'
import OrderContract from './views/order/Detail.vue'

import CompanyUser from './views/hr/CompanyUser.vue'
import CompanyLevel from './views/hr/CompanyLevels.vue'
import CustomerLevel from './views/customer/CompanyLevels.vue'
import Review from './views/reivewSet/Review.vue'
import ReviewList from './views/reivewSet/ReviewList.vue'
import ReviewDetail from './views/reivewSet/ReviewDetail.vue'
import CompanyUsers from './views/customer/CompanyUser.vue'
import Deliver from './views/customer/Deliver.vue'
import SumItem from './views/statist/Buy.vue'

import SaleCredit from './views/sale/Credit.vue'
import Invoice from './views/customer/Invoice.vue'
import InvoiceSet from './views/company/InvoiceSet.vue'
import InvoiceManage from './views/invoice/InvoiceManage.vue'
import SettlementManage from './views/invoice/SettlementManage.vue'
import SettlementDetail from './views/invoice/SettlementDetail.vue'

import SaleOrder from './views/order/SaleOrder.vue'
import SaleOrderDetail from './views/order/SaleOrderDetail.vue'
import SaleOrderDeliver from './views/order/Deliver.vue'
import CouponList from './views/coupon/List.vue';
import SignForProducts from './views/order/SignForProducts.vue'

import PmsOrderManager from './views/history/PmsOrderManager';
import PmsOrder from './views/history/PmsOrder';
import QueryPrice from './views/history/QueryPrice';
import CreateOrderFromPms from './views/tool/CreateOrderFromPms';
import PurchaseOrder from './views/order/PurchaseOrder';
import PurchaseOrderDetail from './views/order/PurchaseOrderDetail';
import ErrorOrder from './views/order/ErrorOrder';
import ErrorOrderDetail from './views/order/ErrorOrderDetail';
import SupplierPurchaseOrder from './views/supplier/PurchaseOrder';
import SupplierPurchaseOrderDetail from './views/supplier/PurchaseOrderDetail';
import SupplierPurchaseDeliver from './views/supplier/PurchaseDeliver';
import SupplierProduct from './views/supplier/Product';
import SupplierAddOneProduct from './views/supplier/AddOneProduct.vue';
import OrderReviewDetail from './views/order/ReviewDetail';
import CustomerApiConfig from './views/customer/ApiConfig.vue';
import PushProduct from './views/customer/PushProduct.vue';
import FutianTools from './views/tool/JCYTool.vue';

import Audit from './views/audit/ShopLog.vue';

import jcyOrder from './views/jcy/Order.vue';
import jcyBill from './views/jcy/Bill.vue';
import jcyInvoice from './views/jcy/Invoice.vue';
import jcySync from './views/jcy/Sync.vue';
import SystemSetting from './views/settings/SystemSetting.vue'
import jcyDeliveryNote from './views/jcy/DeliveryNote.vue';

import QiqiCostCenter from './views/qiqi/CostCenter.vue';
import QiqiUser from './views/qiqi/User.vue';

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/workspace',
      name: 'workspace',
      component: Workspace,
      meta: {title: "首页"},
      children: [
        {
          path: 'dashboard',
          name: 'dashboard',
          component: Dashboard
        },
        {
          path: 'bigScreen',
          name: 'bigScreen',
          component: BigScreen
        },
        {
          path: 'staff',
          name: 'staff',
          component: Staff
        },
        {
          path: 'role',
          name: 'role',
          component: Role
        },
        {
          path: 'module',
          name: 'module',
          component: Module
        },
        {
          path: 'supplier',
          name: 'supplier',
          component: Supplier
        },
        // 个人设置
        {
          path: 'selfinfo',
          name: 'selfinfo',
          component: Selfinfo
        },
        // 系统设置
        {
          path: 'setting/system',
          name: 'systemSetting',
          component: SystemSetting
        },
        {
          path: 'brand',
          name: 'brand',
          component: Brand
        },
        {
          path: 'category',
          name: 'category',
          component: Category
        },
        {
          path: 'category/property',
          name: 'categoryProperty',
          component: CategoryProperty
        },
        {
          path: 'category/label',
          name: 'categoryLabel',
          component: CategoryLabel
        },
        {
          path: 'product/add',
          name: 'addOneProduct',
          component: AddOneProduct,
          props: true,
        },
        {
          path: 'productSet/add',
          name: 'addProduct',
          component: AddProduct,
          props: true,
        },
        {
          path: 'productSet',
          name: 'productSet',
          component: ProductSet,
          props: true,
        },
        {
          path: 'product',
          name: 'product',
          component: Product,
          props: true,
        },
        {
          path: 'productGroup',
          name: 'productGroup',
          component: ProductGroup,
          props: true,
        },
        {
          path: 'article',
          name: 'article',
          component: Article
        },
        {
          path: 'user',
          name: 'user',
          component: User
        },
        {
          path: 'agreement/apply',
          name: 'agreement/apply',
          component: Apply
        },
        {
          path: 'rights/company',
          name: 'company',
          component: Company
        },
        {
          path: 'property/template',
          name: 'propertyTemplate',
          component: Template
        },
        {
          path: 'property/property',
          name: 'propertyProperty',
          component: Property,
        },
        {
          path: 'property/value',
          name: 'propertyValue',
          component: Value,
          props: true
        },
        {
          path: 'property/selectProperty',
          name: 'propertySelectProperty',
          component: SelectProperty,
          props: true
        },
        {
          path: 'agreement/company',
          name: 'customerCompany',
          component: CustomerCompany,
          props: true
        },
        {
          path: 'agreement/product',
          name: 'customerProduct',
          component: CustomerProduct,
          props: true
        },
        {
          path: 'agreement/agreement',
          name: 'agreement',
          component: Agreement,
          props: true,
          meta: {keepAlive: true},
        },
        {
          path: 'agreement/agreementdetail',
          name: 'agreementdetail',
          component: AgreementDetail,
          props: true
        },
        {
          path: 'rfq/rfq',
          name: 'rfq',
          component: Rfq,
          props: true
        },
        {
          path: 'rfq/rfqdetail',
          name: 'rfqdetail',
          component: RfqDetail,
          props: true
        },
        {
          path: 'rfq/quote',
          name: 'quote',
          component: Quote,
          props: true
        },
        {
          path: 'rfq/rfqMgn',
          name: 'rfqMgn',
          component: RfqMgn,
          props: true
        },
        {
          path: 'rfq/rfqdetailMgn',
          name: 'rfqdetailMgn',
          component: RfqDetailMgn,
          props: true
        },
        {
          path: 'rfq/supplier',
          name: 'supplier',
          component: SupplierQuote,
          props: true
        },
        // {
        //   path: 'rfq/supplier',
        //   name: 'supplier',
        //   component: Supplier,
        //   props: true
        // },
        // {
        //   path: 'rfq/supplierQuote',
        //   name: 'supplierQuote',
        //   component: SupplierQuote,
        //   props: true
        // },
        // {
        //   path: 'rfq/store',
        //   name: 'store',
        //   component: Store,
        //   props: true
        // },
        // {
        //   path: 'rfq/storeRfqDetail',
        //   name: 'storeRfqDetail',
        //   component: StoreRfqDetail,
        //   props: true
        // },
        {
          path: 'rfq/store',
          name: 'store',
          component: StoreRfqDetail,
          props: true
        },
        {
          path: 'banner',
          name: 'banner',
          component: Banner,
          props: true
        },
        {
          path: 'brandBanner/brandBanner',
          name: 'brandBanner',
          component: BrandBanner,
          props: true
        },
        {
          path: 'review/product',
          name: 'reviewProduct',
          component: ReviewProduct,
          props: true
        },
        {
          path: '/manager/review/product',
          name: 'managerReviewProduct',
          component: ManagerReviewProduct,
          props: true
        },
        {
          path: 'statistics/user',
          name: 'statisticsUser',
          component: StatisticsUser,
          props: true
        },
        {
          path: 'statistics/popularProducts',
          name: 'popularProducts',
          component: PopularProducts,
          props: true
        },
        {
          path: 'statistics/popularSearch',
          name: 'popularSearch',
          component: PopularSearch,
          props: true
        },
        {
          path: 'statistics/supplier',
          name: 'statisticsSupplier',
          component: StatisticsSupplier,
          props: true
        },
        {
          path: 'statistics/orderStatistics',
          name: 'orderStatistics',
          component: OrderStatistics,
          props: true
        },
        {
          path: 'customer/review',
          name: 'customerReview',
          component: customerReview,
          props: true,
          meta: {keepAlive: true},
        },
        {
          path: 'customer/invoice',
          name: 'invoice',
          component: Invoice,
          props: true,
        },
        {
          path: 'customer/customerLevel',
          name: 'customerLevel',
          component: CustomerLevel,
          props: true,
        },
        {
          path: 'customer/reviewDetail',
          name: 'customerReviewDetail',
          component: customerReviewDetail,
          props: true,
        },
        {
          path: 'customer/mallConfig',
          name: 'customerApiConfig',
          component: CustomerApiConfig,
          props: true,
        },
        {
          path: 'customer/pushProduct',
          name: 'customerPushProduct',
          component: PushProduct,
          props: true,
        },
        {
          path: 'supplier/Company',
          name: 'supplierCompany',
          component: SupplierCompany,
          props: true,
        },
        {
          path: 'order/review',
          name: 'orderReview',
          component: orderReview,
          props: true,
          meta: {keepAlive: true},
        },
        {
          path: 'order/reviewDetail',
          name: 'orderReviewDetail',
          component: OrderReviewDetail,
          props: true,
        },
        {
          path: 'order/contract',
          name: 'orderContract',
          component: OrderContract,
          props: true,
        },
        {
          path: 'order/saleOrderDeliver',
          name: 'saleOrderDeliver',
          component: SaleOrderDeliver,
          props: true,
        },
        {
          path: 'hr/companyUser',
          name: 'companyUser',
          component: CompanyUser
        },
        {
          path: 'hr/companyLevel',
          name: 'companyLevel',
          component: CompanyLevel
        },
        {
          path: 'reviewSet',
          name: 'reviewSet',
          component: Review
        },
        {
          path: 'reviewDetail',
          name: 'reviewDetail',
          component: ReviewList,
          meta: {keepAlive: true},
        },
        {
          path: 'review/reviewDetail',
          name: 'reviewDetails',
          component: ReviewDetail,
          props: true,
        },
        {
          path: 'customer/customerUsers',
          name: 'customerUsers',
          component: CompanyUsers,
          props: true,
        },
        {
          path: 'customer/deliver',
          name: 'deliver',
          component: Deliver,
          props: true,
        },
        {
          path: 'customer/buy',
          name: 'buy',
          component: SumItem,
          props: true,
        },
        // 赊销额度
        {
          path: 'sale/credit',
          name: 'saleCredit',
          component: SaleCredit,
          props: true,
        },
        {//发票设置
          path: 'company/invoiceSet',
          name: 'invoiceSet',
          component: InvoiceSet,
          props: true,
        },
        {//发票管理
          path: 'invoice/invoicePage',
          name: 'invoicePage',
          component: InvoiceManage
        },
        {//结算单
          path: 'invoice/settlement',
          name: 'settlement ',
          component: SettlementManage
        },
        {//结算单
          path: 'invoice/settlementDetail',
          name: 'settlementDetail',
          component: SettlementDetail
        },
        {// 销售订单
          path: 'order/saleOrder',
          name: 'saleOrder',
          component: SaleOrder,
          meta: {keepAlive: true},
        },
        {// 销售订单详情
          path: 'order/saleOrderDetail',
          name: 'saleOrderDetail',
          component: SaleOrderDetail
        },
        {// 订单商品
          path: 'order/signForProducts',
          name: 'signForProducts',
          component: SignForProducts,
        },
        {
          path: 'coupon',
          name: 'coupon',
          component: CouponList,
        },
        // PMS订单管理
        {
          path: 'history/pmsOrderManager',
          name: 'pmsOrderManager',
          component: PmsOrderManager,
        },
        // 客户查询离线订单
        {
          path: 'history/offlineOrder',
          name: 'offlineOrder',
          component: PmsOrder,
        },
        // 查询历史价格
        {
          path: 'history/queryPrice',
          name: 'queryPrice',
          component: QueryPrice,
        },
        // 工具：根据PMS订单创建订单
        {
          path: 'tool/createOrderFromPms',
          name: 'createOrderFromPms',
          component: CreateOrderFromPms,
        },
        // 工具：福田工具集
        {
          path: 'tool/futianTools',
          name: 'futianTools',
          component: FutianTools,
        },
        // 采购订单
        {
          path: 'order/purchaseOrder',
          name: 'purchaseOrder',
          component: PurchaseOrder,
          meta: {keepAlive: true},
        },
        // 采购订单详情
        {
          path: 'order/purchaseOrderDetail',
          name: 'purchaseOrderDetail',
          component: PurchaseOrderDetail,
        },
        // 异常订单
        {
          path: 'order/errorOrder',
          name: 'errorOrder',
          component: ErrorOrder,
          meta: {keepAlive: true},
        },
        // 异常订单详情
        {
          path: 'order/errorOrderDetail',
          name: 'errorOrderDetail',
          component: ErrorOrderDetail,
        },
        // 商品管理(供应商)
        {
          path: 'supplier/product',
          name: 'supplierProduct',
          component: SupplierProduct,
          meta: {keepAlive: true},
        },
        // 供应商添加商品
        {
          path: 'supplier/product/add',
          name: 'supplierAddOneProduct',
          component: SupplierAddOneProduct,
          props: true,
        },
        // 供应商编辑商品
        {
          path: 'supplier/product/edit',
          name: 'supplierEditOneProduct',
          component: SupplierAddOneProduct,
          props: true,
        },
        // 采购订单(供应商)
        {
          path: 'supplier/purchaseOrder',
          name: 'supplierPurchaseOrder',
          component: SupplierPurchaseOrder,
          meta: {keepAlive: true},
        },
        // 采购订单详情(供应商)
        {
          path: 'supplier/purchaseOrderDetail',
          name: 'supplierPurchaseOrderDetail',
          component: SupplierPurchaseOrderDetail,
        },
        // 供货单(供应商)
        {
          path: 'supplier/poDeliver',
          name: 'supplierPODeliver',
          component: SupplierPurchaseDeliver,
        },
        // 安全审计
        {
          path: 'audit/shopLog',
          name: 'shopLog',
          component: Audit,
        },
        // 京采云订单
        {
          path: 'jcy/order',
          name: 'jcyorder',
          component: jcyOrder,
          props: true,
        },
        // 京采云账单
        {
          path: 'jcy/bill',
          name: 'jcybill',
          component: jcyBill,
          props: true,
          meta: {keepAlive: true},
        },
        //京采云开票
        {
          path: 'jcy/invoice',
          name: 'jcyinvoice',
          component: jcyInvoice,
          props: true,
          meta: {keepAlive: true},
        },
        {
          path: 'jcy/deliveryNote',
          name: 'jcyDeliveryNote',
          component: jcyDeliveryNote,
          props: true,
        },
        {
          path: 'jcy/sync',
          name: 'jcySync',
          component: jcySync,
        },
        // 企企成本中心
        {
          path: 'qiqi/costCenter',
          name: 'qiqiCostCenter',
          component: QiqiCostCenter,
        },
        // 企企用户管理
        {
          path: 'qiqi/user',
          name: 'qiqiUser',
          component: QiqiUser,
        }
      ]
    },

  ]
})
